export default "__VITE_ASSET__B_QhUp2e__"